import React from 'react';

const SIZES = {
  sm: { padding: '0 14px', height: 34, fontSize: 'var(--fs-sm)' },
  md: { padding: '0 20px', height: 42, fontSize: 'var(--fs-body)' },
  lg: { padding: '0 28px', height: 52, fontSize: 'var(--fs-body-lg)' },
};

const VARIANTS = {
  primary: {
    background: 'var(--accent-primary)', color: 'var(--text-inverse)',
    border: '1px solid transparent', boxShadow: 'var(--shadow-brand)',
    '--hover-bg': 'var(--accent-primary-hover)',
  },
  neon: {
    background: 'var(--y-neon)', color: 'var(--y-ink)',
    border: '1px solid transparent', boxShadow: '0 8px 22px rgba(0,255,163,.32)',
    '--hover-bg': 'var(--y-neon-600)',
  },
  secondary: {
    background: 'var(--bg-surface)', color: 'var(--text-strong)',
    border: '1px solid var(--border-default)', boxShadow: 'var(--shadow-xs)',
    '--hover-bg': 'var(--y-gray-50)',
  },
  ghost: {
    background: 'transparent', color: 'var(--text-brand)',
    border: '1px solid transparent', boxShadow: 'none',
    '--hover-bg': 'var(--y-blue-50)',
  },
  danger: {
    background: 'var(--y-danger)', color: 'var(--text-inverse)',
    border: '1px solid transparent', boxShadow: 'none',
    '--hover-bg': '#c23636',
  },
};

export function Button({
  children, variant = 'primary', size = 'md', block = false,
  disabled = false, leadingIcon, trailingIcon, style, ...rest
}) {
  const [hover, setHover] = React.useState(false);
  const [active, setActive] = React.useState(false);
  const v = VARIANTS[variant] || VARIANTS.primary;
  const s = SIZES[size] || SIZES.md;

  const base = {
    display: block ? 'flex' : 'inline-flex',
    width: block ? '100%' : 'auto',
    alignItems: 'center', justifyContent: 'center', gap: 'var(--sp-2)',
    fontFamily: 'var(--font-body)', fontWeight: 'var(--fw-bold)',
    letterSpacing: '.005em', lineHeight: 1, whiteSpace: 'nowrap',
    height: s.height, padding: s.padding, fontSize: s.fontSize,
    borderRadius: 'var(--radius-pill)', cursor: disabled ? 'not-allowed' : 'pointer',
    background: hover && !disabled && v['--hover-bg'] ? v['--hover-bg'] : v.background,
    color: v.color, border: v.border,
    boxShadow: active ? 'var(--shadow-xs)' : v.boxShadow,
    opacity: disabled ? 0.5 : 1,
    transform: active && !disabled ? 'translateY(1px)' : 'none',
    transition: 'background var(--dur) var(--ease-out), transform var(--dur-fast) var(--ease-out), box-shadow var(--dur) var(--ease-out)',
    ...style,
  };

  return (
    <button
      type="button" disabled={disabled} style={base}
      onMouseEnter={() => setHover(true)} onMouseLeave={() => { setHover(false); setActive(false); }}
      onMouseDown={() => setActive(true)} onMouseUp={() => setActive(false)}
      {...rest}
    >
      {leadingIcon}{children}{trailingIcon}
    </button>
  );
}
